import type { AuthenticatedUserInfo, Contract, Profile } from "./types"

const parseContract = (contract?: Contract | null): Contract => ({
  airtime: contract?.airtime ?? 0,
  shareOfViewership: contract?.shareOfViewership ?? 0,
  contractUrl: contract?.contractUrl ?? undefined,
  contractExpiry: contract?.contractExpiry ?? undefined,
})

export const parseProfile = (data: Profile): Profile => ({
  id: data.id,
  name: data.name,
  streamingUsername: data.streamingUsername,
  email: data.email,
  accountType: data.accountType,
  residentialAddress: data.residentialAddress,
  language: data.language,
  segment: data.segment,
  countryOfResidence: data.countryOfResidence,
  region: data.region,
  timezone: data.timezone,
  relationshipManager: data.relationshipManager ?? data.managerName ?? null,
  managerId: data.managerId != null ? String(data.managerId) : null,
  managerName: data.managerName ?? null,
  streamingPlatforms:
    data.streamingPlatforms?.map((platform) => ({
      platform: platform.platform,
      url: platform.url,
      isPrimary: platform.isPrimary,
      validationStatus: platform.validationStatus,
      validationError: platform.validationError,
      ...(typeof platform.isActive === "boolean"
        ? { isActive: platform.isActive }
        : {}),
    })) || [],
  discordUsername: data.discordUsername,
  marketingConsent: data.marketingConsent,
  contract: parseContract(data.contract),
  status: data.status,
  createdAt: data.createdAt,
  privacyPolicyAcceptedAt: data.privacyPolicyAcceptedAt,
  lastLoginAt: data.lastLoginAt,
  airtime: data.airtime,
  shareOfAirtime: data.shareOfAirtime,
  lastStreamed: data.lastStreamed,
  streamStatsSyncStatus: data.streamStatsSyncStatus,
  saMetadata: data.saMetadata,
  notes: data.notes,
  tags: data.tags,
  riskProfile: data.riskProfile ?? null,
  trackingStatus: data.trackingStatus,
  preferredGameType: data.preferredGameType,
  location: data.location,
})

export const parseAuthMeInfo = (
  data: AuthenticatedUserInfo
): AuthenticatedUserInfo => ({
  ...(data.id != null && { id: data.id }),
  email: data.email,
  name: data.name,
  accountType: data.accountType,
  requiresPasswordChange: data.requiresPasswordChange,
  requiresPrivacyPolicyAcceptance: data.requiresPrivacyPolicyAcceptance,
  features: data.features,
})
